import { Component, Input } from '@angular/core';
import { IBotonBluetooth } from 'modelos/src';
import { HelperService } from '../../../../../auxiliares/servicios/helper.service';

/**
 * Pestaña Info del detalle de botón BLE. Recibe el botón de la página: antes
 * lo volvía a pedir cada 30 s por su cuenta.
 */
@Component({
  selector: 'app-detalles-boton-ble-info',
  templateUrl: './detalles-boton-ble-info.component.html',
  styleUrl: './detalles-boton-ble-info.component.scss',
  standalone: false,
})
export class DetallesBotonBLEInfoComponent {
  @Input() botonBLE?: IBotonBluetooth;

  get marcaModelo(): string | null {
    const m = this.botonBLE?.modeloDispositivo;
    return [m?.marca, m?.modelo].filter(Boolean).join(' ') || null;
  }

  get fechaCreacion(): string | null {
    const f = this.botonBLE?.fechaCreacion;
    return f ? HelperService.getFechaYHora(f) : null;
  }
}
